module.exports = __webpack_public_path__ + "static/img/1.02366be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Events/AshaTraining/Asha-pics/1.jpg
// module id = vHbR
// module chunks = 0